import { useField } from 'formik';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

import { controlError } from 'utils/error';
import { questionLabelText } from 'utils/question-label';

export interface DatePickerFieldProps extends Omit<
  DatePickerProps,
  'label' | 'value' | 'onChange'
> {
  name: string;
  label?: string;
  fullWidth?: boolean;
  placeholder?: string;
}

export const DatePickerField = ({
  name,
  label,
  fullWidth,
  placeholder,
  ...props
}: DatePickerFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);

  return (
    <DatePicker
      onChange={(value) => helpers.setValue(value)}
      value={field.value === '' ? null : field.value}
      label={label ? questionLabelText(label) : label}
      {...props}
      slotProps={{
        textField: {
          fullWidth,
          error: !!errorText,
          helperText: errorText,
          slotProps: {
            htmlInput: {
              placeholder,
            },
          },
        },
      }}
    />
  );
};
